import { combineReducers } from 'redux';
import authReducer from './adminReducer';
import appReducer from './appReducer';

export default combineReducers({
  app: appReducer,
  user: authReducer,
});
